<template>
  <div
    ref="raiz"
    class="animeAllBG home-fundo-padrao tw-flex tw-flex-col tw-h-screen tw-w-full tw-overflow-hidden tw-relative"
    @click="handlePageClick"
  >
    <vBtnPoliticaPrivacidade
      data-no-start
      @open-privacy-popup="openPrivacyPopup"
    />
    <!-- Foto do topo: metade da tela na Home padrão, tela inteira no totem de evento -->
    <div
      class="top-image-container tw-w-full tw-relative"
      :class="layoutFixo ? 'tw-h-full' : 'tw-h-1/2'"
    >
      <img
        :src="topoUrl"
        alt="Foto principal"
        draggable="false"
        @contextmenu.prevent
        @dragstart.prevent
        @error="usarFallback($event, TOPO_PADRAO)"
        class="top-image tw-w-full tw-h-full tw-object-cover"
      />
    </div>

    <!-- Botão "Toque na tela": na divisa entre as fotos (Home padrão) ou no
         centro exato da tela (evento, que é só uma foto única) -->
    <div
      class="button-container tw-absolute tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-pointer-events-none tw-z-10"
      :style="{ top: layoutFixo ? '50%' : '38%' }"
    >
      <div
        class="pulse-button tw-bg-pink-500 tw-text-white tw-px-72 tw-py-20 tw-rounded-3xl tw-text-7xl tw-font-bold tw-uppercase tw-whitespace-nowrap tw-shadow-2xl tw-cursor-pointer tw-pointer-events-auto"
        :style="botaoStyle"
      >
        Toque na tela
      </div>

      <div
        class="tw-mt-4 tw-text-center tw-text-sm tw-text-gray-600 tw-pointer-events-none tw-rounded-xl tw-p-3 tw-bg-white tw-bg-opacity-50 tw-shadow-lg"
      >
        Ao tocar você está aceitando nossas Políticas de Privacidade
      </div>
    </div>

    <!-- Área inferior com carrossel — não existe no totem de evento -->
    <div
      v-if="!layoutFixo"
      class="bottom-section tw-h-1/2 tw-w-full tw-relative tw-flex tw-flex-col"
    >
      <!-- Carrossel automático -->
      <div
        class="carousel-container tw-flex-1 tw-w-full tw-relative tw-overflow-hidden"
      >
        <div
          class="carousel-track tw-flex tw-h-full"
          :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
          :class="{ 'no-transition': isResetting }"
        >
          <!-- Galeria duplicada para loop infinito (original + cópia) -->
          <div
            v-for="(foto, i) in galeriaLoop"
            :key="i"
            class="carousel-slide tw-w-full tw-h-full tw-flex-shrink-0"
          >
            <img
              :src="foto.dataUrl || foto.url"
              :alt="`Foto ${(i % galeria.length) + 1}`"
              draggable="false"
              @contextmenu.prevent
              @dragstart.prevent
              @error="usarFallback($event, fallbackGaleria(i))"
              class="carousel-image tw-w-full tw-h-full tw-object-cover"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="version-tag">v{{ version }}</div>
    <p v-if="eventError" role="alert" data-no-start class="event-home-error">
      {{ eventError }}
    </p>

    <modalPoliticaPrivacidade data-no-start v-model="privacyPopupOpen" />
  </div>
</template>

<script>
// import etapa from "@/constants/etapaCompra";
import {
  db,
  iniciarCompra,
  loadPrecos,
  reportarVersaoApp,
} from "@/service/firebase";
import { COLLECTION_PERSONALIZA_TOTEM } from "@/service/collectionsNames";
import { homeSemCarrossel } from "@/constants/types/tipoTotem";
import { ehEvento } from "@/constants/types/tipoTotem";
import {
  fetchEventConfig,
  currentAttendance,
  eventCodesRequired,
} from "@/service/eventAttendance";
import { refreshPhotoQuota, reconcileQuotaReservations, releaseUndispatchedQuota, quotaLocalState } from "@/service/eventPhotoQuota";
import { doc, onSnapshot } from "@firebase/firestore";
import anime from "animejs/lib/anime.es.js";
import vBtnPoliticaPrivacidade from "@/components/btnPoliticaPrivacidade.vue";
import modalPoliticaPrivacidade from "@/components/modalPoliticaPrivacidade.vue";

// ── Conteúdo padrão da Home ───────────────────────────────────────────────────
// A Home NUNCA pode aparecer vazia. Quando a config do gestão não carrega
// (primeiro boot offline, cache limpo sem internet, Firestore fora do ar) ou
// quando uma imagem específica não baixa, caímos nestes assets, que vêm dentro
// do bundle e portanto sempre existem.
import TOPO_PADRAO from "@/assets/topo1.jpg";
import embaixo2 from "@/assets/embaixo2.jpg";
import embaixo3 from "@/assets/embaixo3.jpg";
import embaixo4 from "@/assets/embaixo4.jpg";
import embaixo5 from "@/assets/embaixo5.jpg";
import embaixo6 from "@/assets/embaixo6.jpg";
import embaixo7 from "@/assets/embaixo7.jpg";
import embaixo8 from "@/assets/embaixo8.jpg";

const GALERIA_PADRAO = [
  embaixo2,
  embaixo3,
  embaixo4,
  embaixo5,
  embaixo6,
  embaixo7,
  embaixo8,
].map((url, i) => ({ url, ordem: i, padrao: true }));

// Se em 20s do toque o totem ainda estiver na Home, a compra não avançou
// (rede lenta, snapshot perdido, compra expirada no servidor, ou a própria
// criação da compra travou sem chamar sucesso nem erro). A trava de toque
// (`iniciandoCompra`) é liberada em vez de ficar bloqueada para sempre.
const TEMPO_WATCHDOG_MS = 20000;

export default {
  components: {
    vBtnPoliticaPrivacidade,
    modalPoliticaPrivacidade,
  },
  data() {
    return {
      TOPO_PADRAO,
      homeConfigHandle: function () {},
      currentSlide: 0,
      carouselInterval: null,
      carouselTimers: [],
      watchdogNavegacao: null,
      animacoes: [],
      iniciandoCompra: false,
      eventError: "",
      quotaRefreshTimer: null,
      destruido: false,
      isResetting: false,
      privacyPopupOpen: false,
    };
  },
  beforeDestroy() {
    clearInterval(this.quotaRefreshTimer);
    this.destruido = true;
    this.homeConfigHandle();
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
    this.carouselTimers.forEach(clearTimeout);
    this.carouselTimers = [];
    clearTimeout(this.watchdogNavegacao);
    this.pararAnimacoes();
  },
  async mounted() {
    if (ehEvento(this.$store.getters["totem/getTotem"]?.tipoTotem)) {
      this.informarCotaOciosa();
      this.quotaRefreshTimer = setInterval(() => this.informarCotaOciosa(), 30000);
    }
    // Telemetria de versão não pode impedir o Totem de iniciar a Home.
    reportarVersaoApp().catch((error) => {
      console.error("Falha ao informar versão do Totem:", error);
    });
    // Defensivo: qualquer estilo inline residual (ex.: opacidade do botão de
    // uma animação anterior) é apagado aqui. Uma Home recém-montada sempre
    // começa com o conteúdo totalmente visível.
    this.mostrarConteudo();
    // Se a config falhar (ex.: totem ligou offline), ainda assim inicializamos
    // os listeners do Firebase e o carrossel — a Home nunca deve ficar inerte.
    try {
      await this.$store.dispatch("homeConfig/fetchHomeConfig");
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Falha ao carregar config da Home:", e);
    }
    if (this.destruido) return;
    this.initialize();
    this.startCarousel();
  },
  computed: {
    // UID quando este totem é EVENTO (Home exclusiva); null quando usa a global
    fonteTotemId() {
      return this.$store.getters["homeConfig/getFonteTotemId"];
    },
    // O TIPO também decide o layout, qualquer que seja o modelo: EVENTO = uma
    // foto única em tela cheia com o botão ao centro, sem carrossel.
    // O tipo lembrado do boot anterior evita montar a Home errada nos segundos
    // entre o mount e o primeiro snapshot do doc do totem.
    layoutFixo() {
      return homeSemCarrossel(this.$store.getters["totem/getTotem"]);
    },
    // Fonte + layout numa chave só. Trocar o tipo no gestão muda os dois ao
    // mesmo tempo; um watcher por campo buscaria e baixaria a Home duas vezes.
    modalidadeHome() {
      return `${this.fonteTotemId || "global"}|${this.layoutFixo}`;
    },
    topoUrl() {
      const topo = this.$store.getters["homeConfig/getTopo"];
      return topo?.dataUrl || topo?.url || TOPO_PADRAO;
    },
    galeria() {
      const configurada = this.$store.getters["homeConfig/getGaleria"] || [];
      // Galeria vazia (config nunca carregou ou o gestão apagou tudo) → padrão.
      return configurada.length ? configurada : GALERIA_PADRAO;
    },
    galeriaLoop() {
      if (this.galeria.length === 0) return [];
      return [...this.galeria, ...this.galeria];
    },
    botaoCor() {
      return this.$store.getters["homeConfig/getBotaoCor"] || "#ec4899";
    },
    botaoStyle() {
      const cor = this.botaoCor;
      return {
        "--btn-color": cor,
        "--pulse-strong": this.hexToRgba(cor, 0.7),
        "--pulse-transparent": this.hexToRgba(cor, 0),
      };
    },
    getImagensInferiores() {
      return this.galeria.map((f) => f.url);
    },
    version() {
      return process.env.VUE_APP_VERSION;
    },
  },
  watch: {
    // O gestão pode reduzir a galeria ao vivo. Sem reposicionar o índice, o
    // carrossel ficaria travado num slide inexistente (metade inferior branca).
    "galeria.length"(len) {
      if (this.currentSlide >= len) {
        this.currentSlide = 0;
      }
    },
    // O gestão trocou o tipo do totem (PADRAO <-> EVENTO) com o totem ligado,
    // ou o doc do totem chegou diferente do tipo lembrado no boot: troca a
    // fonte e o layout da Home em tempo real, sem reiniciar o totem. A Home de
    // evento usa outra chave de cache (não guarda a galeria), daí a rebusca.
    async modalidadeHome() {
      this.homeConfigHandle();
      this.homeConfigHandle = function () {};
      try {
        await this.$store.dispatch("homeConfig/fetchHomeConfig", {
          force: true,
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Falha ao recarregar config da Home:", e);
      }
      if (this.destruido) return;
      this.ouvirHomeConfig();
      if (this.carouselInterval) {
        clearInterval(this.carouselInterval);
        this.carouselInterval = null;
      }
      this.currentSlide = 0;
      this.startCarousel();
    },
  },
  methods: {
    async informarCotaOciosa() {
      const id = this.$store.getters["totem/getTotem"]?.id;
      if (!id || this.destruido || this.iniciandoCompra) return;
      try { await refreshPhotoQuota(id, true); }
      catch (_) { /* Network failure cannot silently change the ADMIN binding. */ }
    },
    hexToRgba(hex, alpha) {
      if (typeof hex !== "string") return `rgba(236, 72, 153, ${alpha})`;
      let h = hex.trim().replace("#", "");
      if (h.length === 3) {
        h = h
          .split("")
          .map((c) => c + c)
          .join("");
      }
      if (h.length !== 6) return `rgba(236, 72, 153, ${alpha})`;
      const r = parseInt(h.slice(0, 2), 16);
      const g = parseInt(h.slice(2, 4), 16);
      const b = parseInt(h.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    // Uma imagem que não carrega (dataUrl corrompido no cache, URL do Storage
    // fora do ar) é trocada pelo asset local. O guard evita laço infinito caso
    // o próprio fallback falhe.
    usarFallback(event, fallback) {
      const img = event.target;
      if (!fallback || img.dataset.fallbackAplicado) return;
      img.dataset.fallbackAplicado = "1";
      img.src = fallback;
    },
    fallbackGaleria(indice) {
      return GALERIA_PADRAO[indice % GALERIA_PADRAO.length].url;
    },
    async initialize() {
      this.ouvirHomeConfig();
      await loadPrecos();
      if (process.env.NODE_ENV === "development") {
        // ! Atenção nesse ponto qualquer fluxo feito no totem será postado no TOTEM_ID setado no main.js como mockado.
        // this.$root.mockmode(etapa.EDICAO);
      }
    },
    // Atualização AO VIVO da Home: enquanto o totem está na Home, escuta o doc
    // de configuração no Firestore — config/home (totem PADRAO) ou
    // personalizaTotem/{uid} (totem EVENTO). Quando o gestão edita (topo,
    // galeria, cor), os valores em tela atualizam reativamente — sem reload.
    ouvirHomeConfig() {
      // Idempotente: dois caminhos chamam este método na mesma montagem — o
      // initialize() e o watcher de modalidadeHome. Sem cancelar o anterior,
      // sobrariam dois onSnapshot no mesmo doc e o beforeDestroy só desinscreve
      // o último (o primeiro vazaria para sempre).
      this.homeConfigHandle();
      this.homeConfigHandle = function () {};
      // O watcher é async: pode retomar depois do componente já ter sido
      // destruído. Sem esta guarda, reassinaria um listener que ninguém cancela.
      if (this.destruido) return;
      const totemId = this.fonteTotemId;
      const docRef = totemId
        ? doc(db, COLLECTION_PERSONALIZA_TOTEM, totemId)
        : doc(db, "config", "home");
      this.homeConfigHandle = onSnapshot(docRef, (snap) => {
        // EVENTO sem personalização cadastrada: mantém o que está em tela
        // (a config global carregada no fetch) em vez de zerar a Home.
        if (!snap.exists()) return;
        this.$store.dispatch("homeConfig/applyHomeConfig", snap.data());
      });
    },
    openPrivacyPopup() {
      this.privacyPopupOpen = true;
    },
    async handlePageClick(event) {
      if (event.target.closest("[data-no-start]")) return;
      // Sem esta trava, cada toque durante uma rede lenta criava uma compra
      // nova no Firestore.
      if (this.iniciandoCompra) return;
      this.iniciandoCompra = true;
      this.eventError = "";
      if (ehEvento(this.$store.getters["totem/getTotem"]?.tipoTotem)) {
        const id = this.$store.getters["totem/getTotem"]?.id;
        try {
          try {
            await reconcileQuotaReservations(id);
            await releaseUndispatchedQuota(id);
            const quota = await refreshPhotoQuota(id, false);
            const pending = Object.values(quotaLocalState(id).reservations).some((item) => ["PENDING", "DISPATCHING", "UNCERTAIN", "ACCEPTED"].includes(item.status)
              || item.status === "RESERVED" && !!item.paymentRequestId);
            if (quota.enabled && (quota.available === 0 || pending)) {
              await this.$router.push("/cabine/cota-evento");
              return;
            }
          } catch (error) {
            if (error?.response?.status !== 404 || quotaLocalState(id).configured) throw error;
          }
          const config = await fetchEventConfig(id);
          if (this.destruido) return;
          if (config.enabled || currentAttendance(id)) {
            await this.$router.push("/cabine/codigo-evento");
            return;
          }
        } catch (error) {
          // Older APIs have no code endpoint. Preserve their ordinary Event
          // journey only when this device has never observed an enabled gate.
          let legacy = false;
          try {
            legacy =
              error?.response?.status === 404 &&
              !eventCodesRequired(id) &&
              !currentAttendance(id);
          } catch (_) {
            // Corrupt or inaccessible local state must not bypass a gate.
          }
          if (!legacy) {
            this.eventError =
              "Não foi possível verificar o Evento. Confira a conexão e toque novamente.";
            this.iniciandoCompra = false;
            return;
          }
        }
      }
      this.callFirebase();
    },
    callFirebase() {
      this.armarWatchdog();
      iniciarCompra(
        () => {
          if (this.destruido) return;
          this.animeBtn();
          this.$root.CreatListenerPurchase();
        },
        () => {
          // eslint-disable-next-line no-console
          console.error("erro ao iniciar uma compra");
          this.restaurarHome();
        }
      );
    },
    // Rede de segurança do toque. `iniciandoCompra` trava novos toques enquanto
    // espera o listener da compra trocar de rota. Se `iniciarCompra` nunca
    // chamar sucesso nem erro (ex.: escrita no Firestore pendurada sem
    // timeout) ou a troca de rota não acontecer (snapshot perdido, compra já
    // expirada — que redireciona para a própria Home), sem isto o totem
    // ficaria travado, sem aceitar novos toques, para sempre.
    armarWatchdog() {
      clearTimeout(this.watchdogNavegacao);
      this.watchdogNavegacao = setTimeout(() => {
        if (this.destruido) return;
        // eslint-disable-next-line no-console
        console.warn("Compra não avançou a partir da Home — restaurando tela.");
        this.restaurarHome();
      }, TEMPO_WATCHDOG_MS);
    },
    restaurarHome() {
      clearTimeout(this.watchdogNavegacao);
      this.watchdogNavegacao = null;
      this.iniciandoCompra = false;
      this.pararAnimacoes();
      this.mostrarConteudo();
    },
    pararAnimacoes() {
      this.animacoes.forEach((animacao) => {
        try {
          animacao.pause();
        } catch (_) {
          // instância já finalizada
        }
      });
      this.animacoes = [];
    },
    // Remove os estilos inline que o anime.js deixa nos elementos, devolvendo o
    // controle para o CSS (inclusive a animação de pulso do botão).
    mostrarConteudo() {
      const raiz = this.$refs.raiz || this.$el;
      if (!raiz || !raiz.style) return;
      raiz.style.opacity = "";
      const botao = raiz.querySelector(".pulse-button");
      if (botao) {
        botao.style.opacity = "";
        botao.style.transform = "";
      }
    },
    // Feedback de toque no botão (escala + fade), escopado a ESTA instância da
    // Home via ref. Antes era o seletor global ".animeBtnHome" — uma classe que
    // não existe mais no template — e ainda encadeava um fade-out da tela
    // inteira esperando a troca de rota; como essa troca depende de rede
    // (Firestore), a tela podia ficar apagada indefinidamente se a navegação
    // atrasasse ou nunca chegasse. A Home agora nunca esconde a si mesma: quem
    // faz a transição visual entre telas é a troca de rota, não esta animação.
    animeBtn() {
      const botao = this.$refs.raiz
        ? this.$refs.raiz.querySelector(".pulse-button")
        : null;
      if (!botao) return;
      const animation = anime({
        targets: botao,
        scale: {
          value: 1.3,
          delay: 50,
          duration: 500,
        },
        opacity: {
          value: 0,
          delay: 100,
          duration: 500,
          easing: "easeInOutExpo",
        },
      });
      this.animacoes.push(animation);
    },
    callInitialCabine() {
      this.animeBtn();
    },
    startCarousel() {
      // Evento não tem carrossel — sem isto sobraria um setInterval de 5s
      // rodando a Home inteira sem nada para animar.
      if (this.layoutFixo) return;
      this.carouselInterval = setInterval(() => {
        const len = this.galeria.length;
        if (len === 0) return;

        this.currentSlide++;

        // `>=` e não `==`: se a galeria encolher ao vivo o índice pode passar
        // do tamanho e nunca mais bater na igualdade.
        if (this.currentSlide >= len) {
          this.agendarCarrossel(() => {
            this.isResetting = true;
            this.currentSlide = 0;
            this.agendarCarrossel(() => {
              this.isResetting = false;
            }, 50);
          }, 500);
        }
      }, 5000);
    },
    agendarCarrossel(acao, ms) {
      const id = setTimeout(() => {
        this.carouselTimers = this.carouselTimers.filter((t) => t !== id);
        if (this.destruido) return;
        acao();
      }, ms);
      this.carouselTimers.push(id);
    },
  },
};
</script>

<style lang="scss" scoped>
// Fundo padrão da própria Home: mesmo que TODAS as imagens falhem, a tela
// mostra a identidade visual do totem em vez de branco.
.home-fundo-padrao {
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../assets/fundo.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

// Estilos para o carrossel
.carousel-track {
  transition: transform 0.5s ease-in-out;
}

.carousel-track.no-transition {
  transition: none;
}

.carousel-image {
  object-fit: cover;
}

// Botão "Toque na tela" – tamanho garantido para telas verticais (totem)
.pulse-button {
  animation: pulse 2s infinite;
  background-color: var(--btn-color, #ec4899) !important;
  /* Tamanho mínimo grande: não depender só das classes Tailwind */
  min-width: min(90vw, 28rem);
  padding: clamp(1.5rem, 4vh, 3rem) clamp(2rem, 8vw, 5rem) !important;
  font-size: clamp(2rem, 5vh, 4.5rem) !important;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-strong, rgba(236, 72, 153, 0.7));
  }
  70% {
    transform: scale(1.15);
    box-shadow: 0 0 0 50px var(--pulse-transparent, rgba(236, 72, 153, 0));
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-transparent, rgba(236, 72, 153, 0));
  }
}

// Estilo para a imagem do topo
.top-image {
  object-fit: cover;
}

.version-tag {
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 0.375rem 1rem;
  border-radius: 0.75rem;
  font-size: 1rem;
  z-index: 9999;
  pointer-events: none;
}

// Em janelas muito estreitas mantém o botão legível (não reduz demais)
@media (max-width: 768px) {
  .pulse-button {
    font-size: clamp(1.5rem, 4vw, 2.5rem) !important;
    padding: clamp(1rem, 3vh, 2rem) clamp(1.5rem, 5vw, 3rem) !important;
  }
}
</style>
